import { Role, CancelationUserType, ProcedureStatus } from '@caresend/types';
import { getDisallowRescheduling } from '@caresend/utils';
import { ref } from 'vue';
import { usePortalStore } from '../../../../store/portal/index.js';
import { getStore } from '../../../../../../../store/helpers/initStore.js';

/** PROCEDURE RELATED */
/** Adapted from cloud function `setProcedureStatusesHelper` */
const cancelProcedure = (procedureID, params) => {
    var _a;
    const store = getStore();
    const portalStore = usePortalStore();
    // User type will be set if the procedure is being canceled by a dashboard user
    const { canceledByRole, userType } = params;
    const { type } = (_a = store.state.office.office) !== null && _a !== void 0 ? _a : {};
    /**
     * If a dashboard user is canceling on behalf of an assistant, we know the
     * assistant does not belong to a staffing office and thus the procedure is
     * not reschedulable. Otherwise, we need to check.
     */
    const disallowRescheduling = canceledByRole === Role.SUPERADMIN && userType === CancelationUserType.ASSISTANT
        ? true
        : getDisallowRescheduling(canceledByRole, userType, type);
    portalStore.procedures.setChildOf(procedureID, 'disallowRescheduling', disallowRescheduling, true);
    portalStore.procedures.setChildOf(procedureID, 'status', ProcedureStatus.CANCELED, 'set procedure status to canceled');
    const procedureCanceled = {
        canceledBy: params.canceledBy,
        canceledByRole,
        timestamp: Date.now(),
        ...(userType && { userType }),
        ...(params.detailedReason && { detailedReason: params.detailedReason }),
        ...(params.reason && { reason: params.reason }),
        ...(params.supplyCondition && { supplyCondition: params.supplyCondition }),
    };
    portalStore.procedures.setChildOf(procedureID, 'procedureCanceled', procedureCanceled, 'set procedure canceled info');
    return procedureCanceled;
};
const useProcedureCancellationAlert = () => {
    const isProcedureCancelAlertOpened = ref(false);
    const waypointActionIDToEdit = ref(null);
    const cancelWaypointAction = (waypointActionID) => {
        waypointActionIDToEdit.value = waypointActionID;
        isProcedureCancelAlertOpened.value = true;
    };
    const closeProcedureCancelAlert = () => {
        isProcedureCancelAlertOpened.value = false;
    };
    const openProcedureCancelAlert = (waypointActionID) => {
        waypointActionIDToEdit.value = waypointActionID !== null && waypointActionID !== void 0 ? waypointActionID : null;
        isProcedureCancelAlertOpened.value = true;
    };
    return {
        cancelWaypointAction,
        closeProcedureCancelAlert,
        isProcedureCancelAlertOpened,
        openProcedureCancelAlert,
        waypointActionIDToEdit,
    };
};

export { cancelProcedure, useProcedureCancellationAlert };
